import { Injectable } from '@angular/core';
import { ContentfulService } from './blog/contentful.service';
import { Observable } from 'rxjs';

import { Firestore } from '@angular/fire/firestore';
import { Timestamp } from 'firebase/firestore';
import { LikeService } from './likes.service';
import { StorageUrlCacheService } from './storage-url-cache.service';
import { FirestoreReadCacheService } from './firestore-read-cache.service';

@Injectable({
  providedIn: 'root'
})
export class RemoteDataService {

  private static postDateMs(v: unknown): number {
    if (v instanceof Timestamp) {
      return v.toMillis();
    }
    return new Date(v as string | number | Date).getTime();
  }

  blogPosts = [];
  illustrations = {
    histories: [],
    emptiness: [],
    saveParents: []
  };
  illustrations_response: Observable<any>;


  constructor(
    private _service: ContentfulService,
    private _afs: Firestore,
    private _likesService: LikeService,
    private _storageUrlCache: StorageUrlCacheService,
    private _firestoreReadCache: FirestoreReadCacheService
  ) { }

  loadPosts() {
    this.blogPosts = [];
    void this._firestoreReadCache.getAllPosts(this._afs).then(snapshot => {
      snapshot.forEach(doc => {
        const post = { pictureURL: '', data: {} as typeof doc, bigId: doc.id, likes: 0 };

        this._likesService.getLikes(doc.id).subscribe(likes => {
          post.likes = likes;
        });
        post.data = doc;
        this._storageUrlCache.getDownloadUrl('images/' + String((doc as Record<string, unknown>).postId)).then(
          url => {
            post.pictureURL = url;
            this.blogPosts.push(post);
            this.blogPosts = this.blogPosts.sort((a, b) => {
              const ta = RemoteDataService.postDateMs(a.data.dateSystem);
              const tb = RemoteDataService.postDateMs(b.data.dateSystem);
              return tb - ta;
            });
          }
        ).catch(() => {});
      });
    });
  }

  loadIllustrations() {
    this.illustrations_response = this._service.getAllIllustrations();
    this.illustrations_response.subscribe(() => { });
    this.illustrations_response.forEach(item => {
      item.items = item.items.filter(it => {
        if (it.fields.categoryId === 1) {
          this.illustrations.emptiness.push(
            it.fields
          );
        }
        if (it.fields.categoryId === 2) {
          this.illustrations.saveParents.push(
            it.fields
          );
        }
        if (it.fields.categoryId === 3) {
          this.illustrations.histories.push(
            it.fields
          );
        }
      });
    });
  }

  getIllustrations() {
    return this.illustrations;
  }

  getPosts() {
    return this.blogPosts;
  }
}
